module.exports = __webpack_public_path__ + "media/components/contact/elizabethtown-real-estate-sales-stats-684f47bc4f680f7fb19e47e93cff9f7f.gif";